import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink, Database, Globe } from 'lucide-react';

export const Route = createFileRoute('/admin/settings')({
  component: AdminSettings,
});

function AdminSettings() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold">Einstellungen</h1>
        <p className="text-muted-foreground mt-2">Verwalten Sie die allgemeinen Einstellungen Ihrer Website.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Database className="h-5 w-5 text-primary" />
              </div>
              <div>
                <CardTitle className="text-lg">Datenbank</CardTitle>
                <CardDescription>Backend und Datenbank</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Weiterleitungen, Analytics und andere Daten werden in der Cloud-Datenbank gespeichert.
            </p>
            <Button variant="outline" disabled>
              <Database className="h-4 w-4 mr-2" />Über Admin verwaltet
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Globe className="h-5 w-5 text-primary" />
              </div>
              <div>
                <CardTitle className="text-lg">Website</CardTitle>
                <CardDescription>Live-Website öffnen</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">Öffnen Sie die öffentliche Website in einem neuen Tab.</p>
            <Button variant="outline" asChild>
              <a href="/" target="_blank" rel="noopener noreferrer">
                <ExternalLink className="h-4 w-4 mr-2" />Website öffnen
              </a>
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader><CardTitle>Hinweise</CardTitle></CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p><strong>Weiterleitungen:</strong> Client-seitige Weiterleitungen funktionieren automatisch. Für optimale SEO sollten Sie die generierte Nginx-Konfiguration in Ihrer Server-Konfiguration einfügen.</p>
          <p><strong>Analytics:</strong> Seitenaufrufe werden anonym getrackt (ohne IP/Standort) und nur für eingeloggte Admins sichtbar.</p>
        </CardContent>
      </Card>
    </div>
  );
}
